module.exports = __webpack_public_path__ + "static/media/TemploPan.8148c5bf.png";